import * as React from "react";
import Modal from "../Modal";
import Button from "../Button";
import { Colors } from "../../config/Constants";

interface Props {
  onToggleModalState: (event: boolean) => void;
  onCancelSoldoutConfirm: () => void;
}

const CancelSoldout = ({
  onToggleModalState,
  onCancelSoldoutConfirm,
}: Props) => {
  return (
    <Modal
      variant={"none"}
      setOpenOrClose={(status) => onToggleModalState(status)}
      width={"300px"}
    >
      <div
        style={{
          padding: "1.5rem",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div />
          <div>Cancel Soldout</div>
          <img
            onClick={() => onToggleModalState(false)}
            style={{ width: "1rem", height: "1rem" }}
            src={require("../../assets/images/close.png")}
          />
        </div>
        <div style={{ textAlign: "center",fontSize:'14px' }}>
          Are you sure you want to cancel soldout?
        </div>
        <div style={{ display: "flex", gap: "1rem" }}>
          <Button
            // color={Colors.red}
            label="Cancel"
            variant="outlined"
            onClick={() => onToggleModalState(false)}
          />
          <Button
            color={Colors.red}
            label="Submit"
            variant="filled"
            onClick={onCancelSoldoutConfirm}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CancelSoldout;
